import Button from '@mui/material/Button'
import NameForm from './NameForm'
import { useState } from 'react'
import { LuPlus } from 'react-icons/lu'

interface NetworkInsertProps {
  show?: boolean
  disabled?: boolean
  onCreate: (name: string) => void
}

const NetworkInsert = ({ show, disabled, onCreate }: NetworkInsertProps) => {
  const [showState, setShowState] = useState<boolean>(!!show)

  return showState && !disabled ? (
    <NameForm
      autoFocus
      label="Network Name"
      placeholder="Network"
      onSubmit={onCreate}
      onCancel={() => setShowState(false)}
      lowercase
    />
  ) : (
    <Button
      onClick={() => setShowState(true)}
      startIcon={<LuPlus />}
      size="small"
      variant="outlined"
      disabled={disabled}
    >
      Add Network
    </Button>
  )
}

export default NetworkInsert
